import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-period',
  templateUrl: './leave-period.component.html'
})
export class LeavePeriodComponent implements OnInit {
  public editButton:boolean=false;
  public leavePeriodMonth:string="January";
  public leavePeriodDate:string="01";

  constructor() { }

  ngOnInit() {
  }
  editButtonClicked(){
    this.editButton=true;
    // this.saveButton==false;
  }

  saveButtonClicked(){
    this.editButton=false;
    // this.editButton==false;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/leave-period/leave-period.component.ts